module.exports = __webpack_public_path__ + "img/delete-upload.6184c2db.svg";